import React, { useState } from "react";
import Loader from "../../../../control-components/loader/loader";
import { Dialog } from "@progress/kendo-react-dialogs";
import { NotificationManager } from "src/util/notify";
import ApiHelper from "../../../../helper/api-helper";
import ApiUrls from "../../../../helper/api-urls";
import TextAreaKendoRct from "../../../../control-components/kendo-text-area/kendo-text-area";

const AddClinicComment = ({ onClose, clinicComment, clinicId, regionId }) => {
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState(clinicComment);

  const handleSubmit = () => {
    addUpdateComment();
  };

  const addUpdateComment = async () => {
    setLoading(true);
    
    ApiHelper.postRequest(ApiUrls.UPDATE_CLINIC_COMMENT, {
      clinicId: clinicId,
      regionId: regionId,
      comment: comment,
    })
      .then(() => {
        setLoading(false);
        const message = clinicComment ? "Comment Updated" : "Comment Added";
        NotificationManager.success(message);
        onClose();
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error.message);
      });
  };

  const handleChange = (e) => {
    setComment(e.value);
  };

  return (
    <Dialog
      onClose={() => onClose()}
      title={clinicComment ? "Edit Comment" : "Add Comment"}
      className="small-dialog flag width_90 SmallHeight blue_theme"
      width="40%"
    >
      <div className="edit-client-popup">
        <div className="popup-modal slibling-data" >
          <TextAreaKendoRct
            txtValue={comment}
            onChange={handleChange}
            name="clinicComment"
            placeholder="Enter comment here"
            label="Comment"
            
          />
        </div>
        {loading && <Loader />}
      </div>
      <div className="dialog-footer mt-3">
        <button className="btn btn-primary mr-2" onClick={handleSubmit} disabled={loading}>
          {clinicComment ? "Update" : "Add"}
        </button>
        <button className="btn btn-secondary" onClick={() => onClose()} disabled={loading}>
          Cancel
        </button>
      </div>
    </Dialog>
  );
};

export default AddClinicComment;